namespace RioERP.Common {
    export class MailColumns {
        static columnsKey = 'Common.Mail';
    }
}
